import styled from 'styled-components';

export const StyledNumbersCard = styled.div`
    background: #FFFFFF;
    box-shadow: 0px 4px 20px rgba(89, 102, 137, 0.15);
    border-radius: 16px;
    padding: 19px 20px 30px;
    flex-basis: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 700;
    position: relative;
    
    .cards-title {
        opacity: 0.7;
        font-size: 16px;
        line-height: 19px;
        color: #373647;
        margin-top: 11px;
        text-align: center;
        flex-basis: 30%;
    }
    
    .numbers {
        opacity: 0.7;
        font-size: 28px;
        color: rgba(55, 54, 71);
    }

    .numbers.failed {
        color: #F44197;
    }

    .numbers.money, .numbers.failed {
        opacity: 1;
    }

    .waiting {
        font-weight: 400;
        font-size: 14px;
        color: #373647;
        opacity: 0.7;
        position: absolute;
        bottom: 10px;
    }

    .percentage-bar {
        position: absolute;
        width: 70%;
        bottom: -20px;

        .percentage {
            position: absolute;
            font-weight: 700;
            font-size: 28px;
            line-height: 30px;
            color: var(--bllink-purple);
            bottom: 60px;
            left:50%;
            transform: translateX(-50%);
        }
    }
`